import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSnowflake } from "@fortawesome/free-solid-svg-icons";
import { GameClient } from "../gameClient";
import { Button, ExtraMarketButton } from "../styles/ButtonStyle";
import { InfoLevel } from "../types/uiTypes";
import { UIConstants } from "../../../shared/constants";
import { Sound } from "../../../shared/sound";

declare var gameClient: GameClient;

interface FreezeButtonProps {
	toggleLockShop: () => void;
	sendInfo: (name: string) => void;
	enabled?: boolean;
}

export const FreezeButton = (props: FreezeButtonProps) => {
	const hover = () => {
		if (gameClient) {
			gameClient.playUISound(Sound.Menu)
		}
		props.sendInfo('Lock/Unlock: Lock or Unlock the shop at no cost, the same Immune Cells will appear in the next round if locked.');
	}

	const clear = () => {
		props.sendInfo('');
	}

	const click = () => {
		gameClient.playUISound(Sound.Menu);
		props.toggleLockShop();
	}

	return (
		<ExtraMarketButton disabled={!props.enabled} tabIndex={-1} onMouseEnter={hover} className="goo-button" onClick={click} position={"end"} onMouseLeave={clear}>
			<FontAwesomeIcon size="2x" icon={faSnowflake} />
		</ExtraMarketButton>
	)
}
